import { render, staticRenderFns } from "./featureCard.vue?vue&type=template&id=fc18d5a6&"
import script from "./featureCard.vue?vue&type=script&lang=js&"
export * from "./featureCard.vue?vue&type=script&lang=js&"
import style0 from "./featureCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports